import { InvoiceStatus, InvoiceStatuses } from '../types/invoice-status.type';

export const INVOICE_STATUS_LABELS: Record<InvoiceStatus, string> = {
  [InvoiceStatuses.DRAFT]: 'Brouillon',
  [InvoiceStatuses.SENT]: 'Envoyée',
  [InvoiceStatuses.PAID]: 'Payée',
  [InvoiceStatuses.CANCELLED]: 'Annulée',
};
